import memoizeOne from 'memoize-one';
/**
 * Transforms the chart instrument data to the format the Recharts library
 * requires, which is an object with the name of the category and key-value
 * pairs of the series and their values.
 */
export const transformDataForRecharts = memoizeOne((data, options) => data.categories.map((category, categoryIndex) => {
    const rechartsSeries = data.series.reduce((out, { label, data }) => {
        const { value } = getSeriesValue(data[categoryIndex]);
        const omitValue = options.omitZero ? !value : value === null;
        return omitValue ? out : Object.assign(Object.assign({}, out), { [label]: value });
    }, {});
    const rechartsCategory = Object.assign({ name: category.label }, rechartsSeries);
    return rechartsCategory;
}));
/**
 * Returns the value object of a series corresponding to a given category. If
 * the input is a number or null (legacy data types), it is converted to an
 * object with a `value` property for backwards-compatibility. Otherwise it is
 * returned as-is, or null if the input is undefined.
 */
export const getSeriesValue = (input) => {
    var _a;
    const isPrimitive = input === null || typeof input === 'number';
    if (isPrimitive) {
        return { value: input };
    }
    return {
        value: (_a = input === null || input === void 0 ? void 0 : input.value) !== null && _a !== void 0 ? _a : null,
        metrics: input === null || input === void 0 ? void 0 : input.metrics,
    };
};
